import HeroCarousel from "./components/HeroCarousel";
import CategoryQuickLinks from "./components/CategoryQuickLinks";
import SectionHeader from "@/components/base/SectionHeader";
import MovieCard from "@/components/base/MovieCard";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { getHotMovies, getLatestMovies } from "@/utils/movie";

export default function Home() {
  const latest = getLatestMovies(8);
  const hot = getHotMovies(8);

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />

      <main className="pt-16">
        <h1 className="sr-only">蓝莓视频 - 高清影视资源在线播放平台</h1>
        <HeroCarousel />

        <section className="px-4 md:px-8 py-8 md:py-10">
          <SectionHeader icon="ri-apps-2-line" title="分类快捷入口" subtitle="快速定位你想看的影视类型" />
          <CategoryQuickLinks />
        </section>

        <section className="px-4 md:px-8 pb-10 md:pb-14">
          <SectionHeader
            icon="ri-time-line"
            title="最新影视推荐"
            subtitle="近期上线的电影与电视剧"
            moreTo="/category/latest"
          />
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-5">
            {latest.map((movie) => (
              <MovieCard key={movie.id} movie={movie} />
            ))}
          </div>
        </section>

        <section className="px-4 md:px-8 pb-10 md:pb-14">
          <SectionHeader
            icon="ri-fire-line"
            title="热门影视推荐"
            subtitle="按播放热度精选的口碑佳作"
            moreTo="/category/hot"
          />
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-5">
            {hot.map((movie, i) => (
              <MovieCard key={movie.id} movie={movie} rank={i + 1} />
            ))}
          </div>
        </section>

        <section className="px-4 md:px-8 pb-14 md:pb-20">
          <div className="rounded-lg bg-background-100 border border-background-200/70 p-6 md:p-10">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-foreground-950">
                <i className="ri-tv-2-fill text-xl"></i>
              </span>
              <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
                关于蓝莓视频
              </h2>
            </div>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-4xl">
              蓝莓视频是一个专注于高清影视资源聚合的在线内容平台。我们汇聚电影、电视剧等多元影视类别，以清晰的分类、便捷的搜索与贴心的推荐，
              帮助每一位影视爱好者快速找到心仪作品。无论你是追逐最新大片的影迷，还是偏爱经典佳作与长篇剧集的家庭观众，
              都能在这里轻松开启属于自己的观影之旅。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-stack-line text-accent-500 text-lg"></i>
                海量影视资源
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-search-eye-line text-accent-500 text-lg"></i>
                智能分类搜索
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-device-line text-accent-500 text-lg"></i>
                多设备便捷浏览
              </div>
            </div>
          </div>
        </section>
      </main>

      <SiteFooter />
    </div>
  );
}